import { styled } from '@mui/material'

export const BaseLabel = styled('div')`
  display: inline-block;
  zoom: 1;
  font-size: ${props => props.fontSize};
  margin: ${props => props.margin};
  line-height: 22px;
`
export const ColorLabel = styled('span')`
  float: left;
  margin-right: 5px;
  width: 22px;
  height: 22px;
  background-color: ${props => props.color};
`
